import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'

const useStyles = makeStyles(() => ({
  starBtn: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '2px',
    color: 'var(--color-contrast-neutral-300)',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '&:hover': {
      color: 'var(--color-warning-500)'
    },
    '&:disabled': {
      cursor: 'default'
    }
  },
  active: {
    color: 'var(--color-warning-500)'
  }
}))

function FavoriteStarButton ({ isFavorite, loading, disabled, onClick, size }) {
  const classes = useStyles()
  const iconSize = size === 'sm' ? 12 : 14
  const fontSize = size === 'sm' ? '16px' : '18px'

  return (
    <button
      className={`${classes.starBtn} ${isFavorite ? classes.active : ''}`}
      onClick={onClick}
      disabled={disabled || loading}
      title={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
      style={{ fontSize, width: fontSize, height: fontSize }}
    >
      {loading
        ? <CircularProgress size={iconSize} thickness={5} />
        : (isFavorite ? '\u2605' : '\u2606')}
    </button>
  )
}

FavoriteStarButton.propTypes = {
  isFavorite: PropTypes.bool,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['sm', 'md'])
}

FavoriteStarButton.defaultProps = {
  isFavorite: false,
  loading: false,
  disabled: false,
  onClick: () => {},
  size: 'md'
}

export default FavoriteStarButton
